module.exports = __webpack_public_path__ + "img/glassquality_2.971f2ed6.png";